<template>
    <el-container class="page">
        <el-aside :width="isCollapse ? 'auto' : '180px'" class="page-aside">
            <Menu @router-change="handleRouterChange" />
        </el-aside>
        <el-container class="page-main">
            <el-header>
                <Header @router-change="handleRouterChange" />
            </el-header>
            <el-main class="page-container">
                <div
                    class="page-inner"
                    v-loading="!internalRouter && isBeginLoadChildApp"
                >
                    <!-- 主应用自己的容器 -->
                    <div v-if="internalRouter">
                        <router-view />
                    </div>
                    <!-- 给子应用挂在的容器 -->
                    <div v-show="!internalRouter" id="subapp-viewport"></div>
                </div>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import { mapGetters } from 'vuex';
import { start } from 'qiankun';
import { Menu, Header } from './components/index';
import platformName from '@/common/public-platform';
import { getCookie } from '@/utils/cookie';

export default {
    components: {
        Menu,
        Header
    },
    data() {
        return {
            visible: false,
            userName: this.$store.state.userInfo.userName,
            titleInfo: undefined,
            internalRouter: true // 是否是主应用内部的路由
        };
    },
    computed: {
        ...mapGetters([
            'permissionRouters',
            'isBeginLoadChildApp',
            'isCollapse'
        ])
    },
    watch: {
        permissionRouters(val) {
            if (val) {
                this.startQianKun();
            }
        },
        isBeginLoadChildApp(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.internalRouter = false;
            }
        }
    },
    mounted() {
        this.startQianKun();
    },
    methods: {
        // 路由变化
        handleRouterChange(val) {
            this.internalRouter = val;
        },
        // 启动乾坤
        startQianKun() {
            // 下发token到子应用
            if (this.permissionRouters.length > 0 && !window.qiankunStarted) {
                window.qiankunStarted = true;
                start({
                    // fetch(url, options = {}, ...args) {
                    //     if (process.env.VUE_APP_ENV === 'stable') {
                    //         let urls = platformName.map(item => {
                    //             return process.env[
                    //                 `VUE_APP_SUB_${item.shortName.toUpperCase()}`
                    //             ];
                    //         });
                    //         if (urls.includes(url)) {
                    //             options.headers = Object.assign(
                    //                 {
                    //                     x_hades_env_identity:
                    //                         getCookie('X-Hades-Env-Identity') ||
                    //                         ''
                    //                 },
                    //                 options.headers
                    //             );
                    //         }
                    //     }
                    //     return window.fetch(url, options, ...args);
                    // }
                    fetch(url, options = {}) {
                        if (process.env.VUE_APP_ENV === 'stable') {
                            const urls = platformName.map(item => {
                                return process.env[
                                    `VUE_APP_SUB_${item.shortName.toUpperCase()}`
                                ];
                            });
                            // @ts-ignore
                            if (urls.includes(url)) {
                                options.headers = Object.assign(
                                    {
                                        'X-Hades-Env-Identity':
                                            getCookie('X-Hades-Env-Identity') ||
                                            ''
                                    },
                                    options.headers
                                );
                            }
                        }
                        if (
                            url.indexOf('.css') === -1 &&
                            url.indexOf('.js') === -1
                        ) {
                            options.cache = 'no-store';
                        }
                        return window.fetch(url, options);
                    },
                    excludeAssetFilter: assetUrl => {
                        const whiteList = [];
                        const whiteWords = ['cdn.ckeditor.com'];
                        if (whiteList.includes(assetUrl)) {
                            return true;
                        }
                        return whiteWords.some(w => {
                            return assetUrl.includes(w);
                        });
                    }
                });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.page {
    height: 100vh;
    &-aside {
        background: #2e323f;
        width: 180px;
        z-index: 1111; // 为了解决子应用的样式问题，临时hack一下
    }
    &-main {
        background: #2e323f;
        padding-right: 10px;
        overflow-x: hidden;
        ::v-deep {
            .el-header {
                padding: 0;
            }
        }
        .page-container {
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
            height: calc(100vh - 74px);
            position: relative;
            background: #f8f8f8;
            margin-bottom: 10px;
            padding: 0 16px 16px;
            overflow: auto;
            .page-inner {
                position: relative;
                min-width: 800px;
                height: calc(100vh - 90px);
                box-sizing: border-box;
                background: #fff;
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
                border-radius: 4px;
                border: 1px solid #ebebeb;
            }
        }
        #subapp-viewport {
            background: #fff;
            height: 100%;
            overflow-x: hidden;
            overflow-y: scroll;
        }
    }
    // 重置样式
    :deep(.el-header) {
        padding: 0;
    }
    :deep(.el-menu) {
        border-right: 0;
    }
}
</style>
